import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { aboutData } from '@/mocks/about';

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main className="min-h-screen pt-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="py-8 md:py-12 text-center">
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
              {aboutData.brand.title}
            </h1>
            <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
              {aboutData.brand.subtitle}
            </p>
          </section>

          <section className="pb-10 md:pb-14">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-4">
                品牌介绍
              </h2>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
                {aboutData.brand.intro}
              </p>
              <div className="bg-background-100/70 rounded-lg p-6 mb-8">
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                  <div className="text-center">
                    <p className="text-sm text-foreground-500 mb-1">使命</p>
                    <p className="text-sm font-medium text-foreground-800">
                      {aboutData.brand.mission}
                    </p>
                  </div>
                  <div className="text-center">
                    <p className="text-sm text-foreground-500 mb-1">愿景</p>
                    <p className="text-sm font-medium text-foreground-800">
                      {aboutData.brand.vision}
                    </p>
                  </div>
                  <div className="text-center">
                    <p className="text-sm text-foreground-500 mb-1">价值观</p>
                    <div className="flex flex-wrap justify-center gap-1.5">
                      {aboutData.brand.values.map((v) => (
                        <span
                          key={v}
                          className="px-2 py-0.5 rounded-md text-xs bg-primary-100 text-primary-700"
                        >
                          {v}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="py-10 md:py-14 bg-background-100/70 -mx-4 md:-mx-6 px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-8 text-center">
                口碑见证
              </h2>

              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6 mb-10">
                {aboutData.reputation.stats.map((stat) => (
                  <div
                    key={stat.label}
                    className="text-center p-4 md:p-6 rounded-lg bg-background-50 border border-background-200/70"
                  >
                    <p className="text-2xl md:text-3xl font-heading font-bold text-accent-500">
                      {stat.value}
                    </p>
                    <p className="text-xs md:text-sm text-foreground-600 mt-1">
                      {stat.label}
                    </p>
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
                {aboutData.reputation.testimonials.map((t, i) => (
                  <div
                    key={i}
                    className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70"
                  >
                    <div className="flex items-center gap-1 mb-3">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <i
                          key={star}
                          className={`ri-star-fill text-sm ${
                            star <= t.rating ? 'text-accent-500' : 'text-foreground-300'
                          }`}
                        ></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                      "{t.content}"
                    </p>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">
                        {t.name}
                      </p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="py-10 md:py-14">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-6 text-center">
                联系我们
              </h2>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                <div className="flex items-start gap-3 p-4 rounded-lg bg-background-100/70">
                  <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                    <i className="ri-mail-line"></i>
                  </span>
                  <div>
                    <p className="text-xs text-foreground-500 mb-0.5">电子邮箱</p>
                    <p className="text-sm font-medium text-foreground-800">
                      {aboutData.contact.email}
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3 p-4 rounded-lg bg-background-100/70">
                  <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                    <i className="ri-phone-line"></i>
                  </span>
                  <div>
                    <p className="text-xs text-foreground-500 mb-0.5">联系电话</p>
                    <p className="text-sm font-medium text-foreground-800">
                      {aboutData.contact.phone}
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3 p-4 rounded-lg bg-background-100/70">
                  <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                    <i className="ri-map-pin-line"></i>
                  </span>
                  <div>
                    <p className="text-xs text-foreground-500 mb-0.5">办公地址</p>
                    <p className="text-sm font-medium text-foreground-800">
                      {aboutData.contact.address}
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3 p-4 rounded-lg bg-background-100/70">
                  <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                    <i className="ri-wechat-line"></i>
                  </span>
                  <div>
                    <p className="text-xs text-foreground-500 mb-0.5">微信公众号</p>
                    <p className="text-sm font-medium text-foreground-800">
                      {aboutData.contact.wechat}
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3 p-4 rounded-lg bg-background-100/70">
                  <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                    <i className="ri-weibo-line"></i>
                  </span>
                  <div>
                    <p className="text-xs text-foreground-500 mb-0.5">微博</p>
                    <p className="text-sm font-medium text-foreground-800">
                      {aboutData.contact.weibo}
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3 p-4 rounded-lg bg-background-100/70">
                  <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                    <i className="ri-time-line"></i>
                  </span>
                  <div>
                    <p className="text-xs text-foreground-500 mb-0.5">工作时间</p>
                    <p className="text-sm font-medium text-foreground-800">
                      {aboutData.contact.workHours}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '伦理剧精选',
            url: 'https://lunliju.example.com',
            description: '伦理剧精选是国内领先的伦理剧内容推荐平台，致力于为观众筛选最优质的伦理剧作品。',
            email: aboutData.contact.email,
            telephone: aboutData.contact.phone,
            address: {
              '@type': 'PostalAddress',
              streetAddress: aboutData.contact.address,
            },
            sameAs: [],
          }),
        }}
      />
    </>
  );
}